/* global translation */

import { hideOnClickOutside, triggerEvent } from './functions';

const miniCartContainer = document.getElementById('mini-cart');
const miniCartButtons = Array.from(document.getElementsByClassName('toggle-mini-cart'));


miniCartButtons.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    hideOnClickOutside(miniCartContainer, 'open-mini-cart');

    document.body.classList.remove('open-mobile-menu');
    document.body.classList.remove('open-search-menu');

    // Prevents the menu to be opened again if it already was open.
    // hideOnClickOutside() will close it if it's open
    if (document.body.classList.contains('open-mini-cart')) {
      return;
    }

    // This is inside of a timout to prevent it from being closed by hideOnClickOutside() as soon as it's opened
    setTimeout(() => {
      document.body.classList.add('open-mini-cart');
    });
  }, 10);
});


jQuery(document).on('click', '#mini-cart ul.mini-dropdown-products div.remove > a', (event) => {
  event.preventDefault();
  const link = event.currentTarget;
  const cartItemId = link.dataset.cartItemKey;
  const confirmed = window.confirm(`${translation.delete_product} "${link.dataset.productName}"?`);

  if (!confirmed) {
    return;
  }

  miniCartContainer.classList.add('wait');

  jQuery.post(translation.ajaxurl, { action: 'maksimer_woocommerce_cart_remove_item', cart_item_key: cartItemId }, () => {
    // Remove li element
    // link.parentNode.parentNode.remove();
    triggerEvent(document.body, 'wc_fragment_refresh');
    setTimeout(() => {
      miniCartContainer.classList.remove('wait');
    }, 1500);
  });
});


jQuery(document).on('change', '#mini-cart ul.mini-dropdown-products .quantity input.qty', (event) => {
  event.preventDefault();
  const qtyInput = event.currentTarget;
  const cartItemId = jQuery(qtyInput).closest('li.product').data('cart-item-key');
  const qty = qtyInput.value;

  miniCartContainer.classList.add('wait');

  jQuery.post(translation.ajaxurl, { action: 'maksimer_woocommerce_cart_update_qty', cart_item_key: cartItemId, quantity: qty }, () => {
    triggerEvent(document.body, 'wc_fragment_refresh');
    setTimeout(() => {
      miniCartContainer.classList.remove('wait');
    }, 1500);
  });
});
